import { combineEpics } from 'redux-observable';

import { loadStores } from './loadStores';

export default combineEpics(loadStores);



// WEBPACK FOOTER //
// ./src/scenes/CityStores/services/epics/index.ts